import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-provider',
  templateUrl: './cloud-provider.component.html',
  styleUrls: ['./cloud-provider.component.scss']
})
export class CloudProviderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
